import type { DocSection } from '../types'

export const contactsSection: DocSection = {
  id: 'contacts',
  title: 'Contacts & statut client',
  icon: 'users',
  accent: '#B45309',
  summary: "La vue unifiée de tous les numéros : carnet, statut client, liste noire, enrichissement Google.",
  minRole: 'admin',
  articles: [
    {
      id: 'hub',
      title: 'La page Contacts (vue unifiée)',
      summary: 'Tous les numéros du compte, enrichis et actionnables au même endroit.',
      icon: 'users',
      blocks: [
        { type: 'p', text: "La page **Contacts** regroupe **tous les numéros** connus du compte, enrichis du **carnet** (nom, entreprise), du statut **liste noire** et du statut **client**. C'est le point d'entrée pour retrouver un numéro sans savoir dans quelle liste il se trouve." },
        { type: 'list', items: [
          "**Recherche** par numéro, nom ou entreprise ; filtres par **campagne** et par statut.",
          "**Ajout rapide** d'un contact dans une campagne (numéro, nom, et éventuellement statut client).",
          "Actions directes : marquer **client**, mettre en **liste noire**, et raccourcis vers **Listes de numéros** et **Liste noire**.",
        ] },
        { type: 'callout', variant: 'info', title: 'Fiche maîtresse, campagnes multiples', text: "Un numéro appartient à sa **fiche** (liste de numéros), qui peut être reliée à **plusieurs campagnes** : sa progression est **indépendante** dans chacune. Voir [[campagnes/listes|Listes de numéros & import]]." },
      ],
    },
    {
      id: 'client',
      title: 'Le statut « client »',
      summary: "Protéger vos clients existants des appels de prospection.",
      icon: 'user-check',
      blocks: [
        { type: 'p', text: "Marquer un numéro comme **client** (badge doré ⭐) le **retire de la prospection automatique** : il n'est plus proposé dans la pioche des agents ni composé par le mode progressif — dans **toutes** les campagnes." },
        { type: 'list', items: [
          "L'appel **manuel** d'un client reste possible ; selon la configuration de la campagne, une **confirmation** est demandée avant de composer.",
          "Le statut se pose/retire depuis la page **Contacts** ou depuis la fiche du contact.",
        ] },
        { type: 'callout', variant: 'tip', title: 'Client ≠ liste noire', text: "Un **client** peut toujours être appelé volontairement (relation en cours). Un numéro en **liste noire** est bloqué partout, même en composition manuelle. Voir [[blacklist|Liste noire]]." },
      ],
    },
    {
      id: 'enrichissement',
      title: 'Note Google, avis et lien Maps',
      summary: "Les fiches importées affichent la note Google et un accès direct à Maps.",
      icon: 'star',
      blocks: [
        { type: 'p', text: "Pour les listes issues d'annuaires (Google Places, PagesJaunes…), PexiTalk reconnaît à l'**import CSV** les colonnes de **note** (rating) et de **nombre d'avis** : pendant l'appel, la fiche du contact affiche alors une pastille **note Google + avis**, et une icône **Maps** ouvre la fiche Google Maps du contact (recherche nom + adresse)." },
        { type: 'list', items: [
          "Aucune configuration : si les colonnes sont présentes dans le fichier, l'enrichissement s'affiche.",
          "Les listes **déjà importées** avec ces colonnes en bénéficient aussi.",
          "L'agent y gagne du contexte avant de parler : réputation de l'établissement, localisation.",
        ] },
        { type: 'seealso', items: [
          { to: 'campagnes/listes', label: "Importer une liste de numéros" },
        ] },
      ],
    },
  ],
}
